// @vue-js-cron/light ne reconnaît que les valeurs numériques pour les champs
// "mois" et "jour de la semaine" (pas les abréviations JAN, MON, etc.).
// Cette fonction convertit ces abréviations en leur équivalent numérique
// avant de transmettre l'expression cron au générateur visuel.

const MONTH_MAP = {
	JAN: 1, FEB: 2, MAR: 3, APR: 4, MAY: 5, JUN: 6,
	JUL: 7, AUG: 8, SEP: 9, OCT: 10, NOV: 11, DEC: 12
};

const DOW_MAP = {
	SUN: 0, MON: 1, TUE: 2, WED: 3, THU: 4, FRI: 5, SAT: 6
};

function replace_names(field, map) {
	return field.replace(/[a-zA-Z]+/g, (name) => {
		const value = map[name.toUpperCase()];
		return value !== undefined ? value : name;
	});
}

export function cron_names_to_numbers(expression) {
	if (!expression) return expression;

	const fields = expression.trim().split(/\s+/);
	// Format standard à 5 champs (minute heure jour_du_mois mois jour_de_la_semaine)
	// ou 6 champs si une expression avec secondes est utilisée.
	if (fields.length < 5) return expression;

	const month_idx = fields.length >= 6 ? fields.length - 3 : 3;
	const dow_idx = fields.length >= 6 ? fields.length - 2 : 4;

	fields[month_idx] = replace_names(fields[month_idx], MONTH_MAP);
	fields[dow_idx] = replace_names(fields[dow_idx], DOW_MAP);

	return fields.join(" ");
}
